export const shiftToFrontArray = <T>(arr: T[], target: T): T[] => {
  const index = arr.indexOf(target);
  if (index === -1) {
    return arr;
  }

  const restArray = arr.filter((_, i) => i !== index);

  return [target, ...restArray];
};
